import type { BannerConfig } from '../types';

export interface CountdownParts {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  expired: boolean;
}

export function hasBannerCountdown(banner: Pick<BannerConfig, 'countdownEndsAt'> | null | undefined): boolean {
  const iso = banner?.countdownEndsAt?.trim();
  if (!iso) return false;
  return !Number.isNaN(new Date(iso).getTime());
}

export function getCountdownParts(endsAt: Date, now: Date = new Date()): CountdownParts {
  const diffMs = endsAt.getTime() - now.getTime();
  if (diffMs <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds, expired: false };
}

export function formatCountdownUnit(value: number): string {
  return `${value}`.padStart(2, '0');
}
